import { create } from 'zustand';
import type { ErrorPanelState } from '@typings';

export const useErrorPanelStore = create<ErrorPanelState>((set) => ({
    errorsByScope: {},

    setErrors: (scope, errors): void =>
        set((state) => {
            if (errors.length !== 0) {
                return {
                    errorsByScope: {
                        ...state.errorsByScope,
                        [scope]: errors,
                    },
                };
            }

            if (scope in state.errorsByScope) {
                const { [scope]: _, ...rest } = state.errorsByScope;
                return { errorsByScope: rest };
            }

            return state;
        }),

    clearErrors: (scope): void =>
        set((state) => {
            if (scope in state.errorsByScope) {
                const { [scope]: _, ...rest } = state.errorsByScope;
                return { errorsByScope: rest };
            }
            return state;
        }),

    clearAll: (): void => set({ errorsByScope: {} }),
}));
